<template>
    <section class="section section--cover">
        <div class="section__cover"></div>
        <div class="section__content">
            <img src="~@/assets/logo.svg" alt="Logo Institute of Applied Psychology s.r.o." class="section__logo" />
            <h1 class="section__heading">Učíme<br />vnímat podstatu</h1>
        </div>
        <a href="http://points.psychometry.cz/" target="_blank" class="testing-link">
            <FontAwesomeIcon icon="user" />
            <span>Testovací prostředí</span>
        </a>
    </section>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core'; 
    import { faUser } from '@fortawesome/free-solid-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    library.add(faUser);

    export default {
        name: 'Cover',
        components: {
            FontAwesomeIcon
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    
    .section {
        position: relative;

        &__cover {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-image: url('~@/assets/cover.jpg');
            background-size: cover;
            background-position: center center;
        }

        &__content {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8rem;
            z-index: 1;

            img {
                width: 150px;
                height: 150px;
            }
        }

        &__heading {
            margin: 0;
            text-align: right;
            font-family: 'Roboto Slab', sans-serif;
            font-weight: 400;
            font-size: 5rem;
            color: #fff;
        }

        &--cover {
            height: 80vh;
            padding: 0;
        }
    }

    .testing-link {
        position: fixed;
        top: 4rem;
        right: 0;
        width: auto;
        height: 4rem;
        padding: 0 1.5rem;
        border-top-left-radius: 2rem;
        border-bottom-left-radius: 2rem;
        line-height: 4.1rem;
        text-align: center;
        text-decoration: none;
        background-color: #385dae;
        z-index: 3;
        transform: translateX(148px);
        transition: transform .15s ease-in-out;

        svg {
            margin: 0 1rem 0 0;

            path {
                color: #fff;
            }
        }

        span {
            font-weight: 300;
            color: #fff;
        }

        &:hover {
            transform: translateX(0);
        }
    }

    @media (max-width: 999px) {

        .section__cover {
            background-image: url('~@/assets/cover-tablet.jpg');
        }
    }

    @media (max-width: 767px) {

        .section {

            &__content {
                padding: 4rem;
            }

            &__heading {
                font-size: 4rem;
            }
        }
    }

    @media (max-width: 499px) {

        .section {

            &__content {
                padding: 2rem;

                img {
                    width: 100px;
                    height: 100px;
                }
            }

            &__heading {
                font-size: 2.5rem;
            }

            &__cover {
                background-image: url('~@/assets/cover-mobile.jpg');

                &::after {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    display: block;
                    width: 100%;
                    height: 10vh;
                    background: linear-gradient(0deg, rgba(0, 0, 0, .5) 26%, rgba(255, 255, 255, 0) 100%);
                    content: "";
                }
            }

            img {
                width: 8rem;
                height: 8rem;
            }

            &--cover {
                height: 30vh;
            }
        }
    }

</style>
